<template>
    <div class="estate-show" sticky-container>
        <calculate-mortgage
            v-if="showCalculateMortgage"
            :price="estate.numeric_price"
            :durations="mortgageDurations"
            :options="estate.mortgage_data"
            :estate-id="estate.id"
        />

        <custom-offer
            v-if="showCalculateMortgage"
            :estate="estate"
        />

        <!-- <sticky class="estate-data-container">
            <estate-data-es
                :estate="estate"
                :back-link="backLink"
                :lang="lang"
            />
        </sticky> -->

        <slot name="breadcrumb" />

        <div class="estate-detail">
            <div class="container">
                <section>
                    <estate-media
                        :estate="estate"
                        :config_estate="config_estate"
                    />
                </section>

                <section>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-8">
                                <div class="card-sticky sticky" v-sticky="true" sticky-offset="{top: 46, bottom: 0}" on-stick="onStick" sticky-z-index="20">
                                    <estate-data-static-v2
                                        :estate="estate"
                                        :back-link="backLink"
                                        :lang="lang"
                                        :show-calculate-mortgage="showCalculateMortgage"
                                    />
                                </div>

                                <estate-content-v2
                                    v-if="estate.ad_type === 'estate'"
                                    :config_estate="config_estate"
                                    :estate="estate"
                                    :show-calculate-mortgage="showCalculateMortgage"
                                >
                                    <template slot="title">
                                        <slot name="estate-title" />
                                    </template>

                                    <template slot="subtitle">
                                        <slot name="estate-subtitle" />
                                    </template>

                                    <template slot="description">
                                        <slot name="estate-description" />
                                    </template>

                                    <template slot="features">
                                        <slot name="estate-features" />
                                    </template>

                                    <template slot="costs">
                                        <slot name="estate-costs" />
                                    </template>
                                </estate-content-v2>

                                <construction-content
                                    v-if="estate.ad_type === 'construction'"
                                    :estate="estate"
                                >
                                    <template slot="title">
                                        <slot name="estate-title" />
                                    </template>

                                    <template slot="description">
                                        <slot name="estate-description" />
                                    </template>
                                </construction-content>

                                <estate-service v-if="config_estate.services && estate.services" :services="estate.services" />

                                <div
                                    v-if="estate.latitude && estate.longitude"
                                    class="map"
                                >
                                    <modal-opener
                                        name="media-gallery" 
                                        :data="{
                                            estate: estate,
                                            first_active: 'map',
                                            buttons: true
                                        }">
                                        <div>
                                            <img src="/img/icons/expand.svg">
                                            <span>{{ trans('labels.expand') | capitalize }}</span>
                                        </div>
                                    </modal-opener>

                                    <detail-map
                                        :latitude="estate.latitude"
                                        :longitude="estate.longitude"
                                        :tecnomaps-endpoint="mapsEndpoint"
                                        :exact="estate.show_map ? true : false"
                                        :marker="mapsMarker"
                                    />
                                </div>

                                <div v-if="estate.ad_type === 'estate'" class="row mt-2">
                                    <div class="col-12 p-0">
                                        <similar-estates :estate="estate" />
                                    </div>
                                </div>
                            </div>

                            <div ref="leads_column" class="leads-column col-sm-4 pr-0">
                                <!-- <sticky :header-offset="91"> -->
                                    <tabs class="lead-forms mb-2" ref="tabs">
                                        <template slot="tabs-content">
                                            <tab
                                                class="p-0"
                                                :name="trans('labels.lead') | capitalize"
                                                :selected="true"
                                                :key="0"
                                                :id="0"
                                            >
                                                <lead-form :estate="estate" />
                                            </tab>

                                            <!-- <tab
                                                :name="trans('labels.appointments') | capitalize"
                                                :key="1"
                                                :id="1"
                                            >
                                                <appointment-form :estate="estate" />
                                            </tab> -->
                                        </template>
                                    </tabs>
                                <!-- </sticky> -->

                                <agency-card
                                    :track-phone="true"
                                    :estate-type="estate.ad_type"
                                    :estate-id="estate.id"
                                    :agency="estate.agency"
                                    :show-email="false"
                                    :team-per-page="[[0, 2], [769, 3]]"
                                >
                                    <template slot="header">
                                        <div class="agency-card-header">
                                            <h4>
                                                {{ trans('labels.estate_by') }}
                                            </h4>
                                        </div>
                                    </template>
                                </agency-card>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <div v-if="config_estate.whatsapp_popup && estate.agency.whatsapp">
            <transition name="whatsapp">
                <div v-if="whatsappPopup" class="box_whatsapp">
                    <!-- <div @click="whatsappPopupClose()" class="wa-label">Chiudi X</div> -->
                    <a :href="'https://wa.me/' + this.estate.agency.whatsapp" target="_blank">
                        <div class="whatsapp_icon">
                            <div class="wa-icon" style="mask-image: url('/img/whatsapp.svg');" alt="Apri Whatsapp"></div>
                        </div>
                    </a>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import AgencyCard from '../../components/agencies/Card'
import CalculateMortgage from '../../components/estates/CalculateMortgage'
import ConstructionContent from '../../components/estates/ConstructionContent'
import CustomOffer from '../../components/estates/CustomOffer'
import DetailMap from '../../components/DetailMap'
import EstateData from '../../components/estates/Data-v2'
import EstateDataStatic from '../../components/estates/Data-static-v2'
import EstateMedia from '../../components/estates/Media'
import EstateContent from '../../components/estates/EstateContent-v2'
import EstateService from '../../components/estates/EstateService'
import LeadForm from '../../components/LeadForm'
import AppointmentForm from '../../components/AppointmentForm'
import ModalOpener from '../../components/ModalOpener'
import Similar from '../../components/estates/Similar'
// import Sticky from '../../components/Sticky'
import Tabs from '../../components/Tabs'
import Tab from '../../components/Tab'
import Sticky from 'vue-sticky-directive'
Vue.use(Sticky)

export default {
    components: {
        'agency-card': AgencyCard,
        'calculate-mortgage': CalculateMortgage,
        'construction-content': ConstructionContent,
        'custom-offer': CustomOffer,
        'detail-map': DetailMap,
        'estate-content-v2': EstateContent,
        'estate-data-v2': EstateData,
        'estate-data-static-v2': EstateDataStatic,
        'estate-media': EstateMedia,
        'estate-service': EstateService,
        'lead-form': LeadForm,
        'appointment-form': AppointmentForm,
        'modal-opener': ModalOpener,
        'similar-estates': Similar,
        // 'sticky': Sticky,
        'tabs': Tabs,
        'tab': Tab,
    },

    props: {
        backLink: {
            type: String,
            required: false,
        },

        config_estate: {
            type: Object,
            required: true,
        },

        estate: {
            type: Object,
            required: true,
        },

        mapsEndpoint: {
            type: String,
            required: true,
        },

        mapsMarker: {
            type: String,
            required: true,
        },

        mortgageDurations: {
            type: Object,
            required: false,
        },
        
        showCalculateMortgage: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            whatsappPopup: false
        }
    },

    computed: {
        lang() {
            return this.$root.lang.estate_detail
        },
    },

    mounted() {
        window.events.$on('leadFormFocus', () => {
            console.log('scroll')

            window.scrollTo(0, this.$refs.leads_column.offsetTop - 80)
        })

        if (this.estate.agency.whatsapp) {
            setTimeout(() => {
                this.whatsappPopup = true
            }, 1000);
        }
    }
}
</script>